import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { axiosClient } from '../../../core/axios-client'

const fetchSubscription = createAsyncThunk('fetchSubscription', async () => {
  const response = await axiosClient.get('/companies/selected/subscription')
  return response.data
})

const bindSubscriptionCard = createAsyncThunk(
  'bindSubscriptionCard',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post('/companies/selected/subscription/card')
      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Не удалось начать привязку карты')
    }
  }
)

const paySubscriptionInvoice = createAsyncThunk(
  'paySubscriptionInvoice',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(`/companies/selected/subscription/invoices/${id}/pay`)
      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Не удалось создать оплату')
    }
  }
)

const initialState = {
  plan: null,
  currentPeriod: null,
  plans: [],
  invoices: [],
  isLoading: false,
  error: null,
}

export const slice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSubscription.pending, (state) => {
      state.isLoading = true
      state.error = null
    })
    builder.addCase(fetchSubscription.fulfilled, (state, { payload }) => {
      state.plan = payload.plan
      state.currentPeriod = payload.current_period
      state.plans = payload.plans || []
      state.invoices = payload.invoices || []
      state.isLoading = false
    })
    builder.addCase(fetchSubscription.rejected, (state, { error }) => {
      state.isLoading = false
      state.error = error?.message || 'Не удалось загрузить данные подписки'
    })
  },
})

export { fetchSubscription, bindSubscriptionCard, paySubscriptionInvoice }

export default slice.reducer
